module.exports = __webpack_public_path__ + "static/media/fashion_men-big.20812579.png";